import { toDate as toDate_ } from "date-fns";

import type { Time } from "../time";

// Overload the date-fns/toDate function to gracefully handle undefined and null values.

export function toDate(time: Time): Date;
export function toDate(time: undefined | null | Time): undefined | Date;
export function toDate(time: undefined | null | Time): undefined | Date {
	return time == null ? undefined : toDate_(time);
}
